import axios from 'axios';
import apisUrls from '../urls';

const updateSectionTitleApi = (values) => {
  return axios.post(apisUrls.updateSingleSectionTitle, values, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export default updateSectionTitleApi;
